import * as types from "../actions/types";



const initialState = {
  list: null,
  loading: false,
  adsById: null
};


export default function useful_sites(state = initialState, action) {
  switch (action.type) {
    case types.SET_USEFUL_SITES_LIST:
      return {
        ...state,
        usefulSiteslist: action.payload
      };
          case types.GET_USEFUL_SITES_FILE:
            return {
              ...state,
              file: action.payload
            };
    case types.SET_USEFUL_SITES_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case types.SET_ADS_BY_ID:
      return {
        ...state,
        adsById: action.payload
      };
    default:
      return state;
  }
}